
























































import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SelectRoomComponent from "../../selectRoom/selectRoom.component.vue";
@Component({
  name: "space-diary-selector-component",
  components: {
    SelectRoomComponent,
  },
})
export default class SpaceDiarySelectorComponent extends mixins(
  NotificationEvent
) {
  @Prop({ default: false }) active_prop;
  loader = true;
  text = "";
  space = 0;
  spaces = [];
  roomSelected = null;
  selector = 0;
  roomSelectedId = -1;
  get active(): boolean {
    return this.active_prop;
  }
  set active(e) {
    this.$emit("close", e);
  }
  get selectSpace(): any {
    if (this.space == 0) return null;
    return this.spaces.filter((a) => a.id == this.space)[0];
  }
  mounted() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space.superSpace.id,
      callback: (response) => {
        this.space = response[0].id;
        this.spaces = response;
        this.loader = false;
        this.selector += 1;
        this.selectRoom(null);
      },
      callbackError: () => {
        this.loader = false;
      },
    });
  }

  selectRoom(e) {
    if (!e) {
      this.roomSelectedId = 0;
      this.roomSelected = this.spaces.filter(
        (a) => a.id == this.space
      )[0].scenario.rooms[0];
      return;
    }
    this.roomSelectedId = e.position;
    this.roomSelected = e.room;
  }
  save() {
    const url = `${window.location.origin}/invitation/guest/${
      this.selectSpace.guestInvitationToken
    }/${this.selectSpace.name.replaceAll(" ", "_")}?spaceId=${
      this.selectSpace.id
    }&hasOnboarding=false&room=${
      this.roomSelected ? this.roomSelected.id : null
    }&alwaysGrazing=true`;

    const element = document.createElement("a");
    element.href = url;
    element.target = "_blank";
    element.innerText = this.text === "" ? url : this.text;
    const editor = document.getElementsByClassName("ql-editor")[0];
    editor.appendChild(element);
    this.active = false;
  }
}
